var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"audio-error"},[_c('div',[_c('i',{staticClass:"el-icon-error"}),_c('p',[_vm._v(_vm._s(_vm.i18n.Pra.text15))])]),_c('div',{staticClass:"audio-error-btn",on:{"click":_vm.open}},[_vm._v(_vm._s(_vm.i18n.Pra.text16))]),_c('AudioOpen',{attrs:{"visible":_vm.showDialog},on:{"closeDialog":_vm.handleDialog}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }